
import emailListProvider from '../../../json/emailListProvider.json';
import allowedEmailListProvider from '../../../json/allowedEmailListProvider.json';

const validateBusinessEmail = email => {
    const emailDomain = email.includes('@') ? email.split('@')[1] : '';

    if(allowedEmailListProvider.includes(emailDomain)) {
        return true;
    }

    return !emailListProvider.includes(emailDomain);
};

export default validateBusinessEmail;